<template>
  <div>
    <p
      v-if="description"
      class="dataset-info-box-description m-0"
      v-html="renderedDescription"
    >
    </p>
    <span v-else>
      <p class="text-muted font-italic m-0" data-cy="dataset-description">
        {{ $t("message.catalogsAndDatasets.noDescriptionAvailable") }}
      </p>
    </span>
  </div>
</template>

<script>
import {
  helpers
} from "@piveau/piveau-hub-ui-modules";
import { marked } from "marked";
import DOMPurify from "dompurify";

const { truncate } = helpers;

export default {
  props: {
    description: {
      type: String,
      default: null,
    },
    descriptionMaxLength: {
      type: Number,
      default: null,
    },
  },

  computed: {
    truncatedDescription() {
      return this.descriptionMaxLength && truncate(this.description, this.descriptionMaxLength);
    },
    renderedDescription() {
      const text = this.truncatedDescription || this.description;
      const safeText = typeof text === "string" ? text : String(text ?? "");
      try {
        return DOMPurify.sanitize(marked.parse(safeText.trim(), { smartLists: true }));
      } catch (error) {
        console.error("Failed to render markdown description", error);
        return DOMPurify.sanitize(safeText);
      }
    },
  }
};
</script>
